import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";
import moment from "moment";

import "./Offers.styl";
import {
  setPage,
  setSort,
  setSearchField,
  generateSearchHash
} from "../../common/offer/actions";
import { hashFromObj } from "../../common/lib/utils/hash";
import Pagination from "../components/Pagination/Pagination";

moment.locale("pl");

class Offers extends React.Component {
  componentDidMount() {
    const { setPage, setSearchField, agencyUID } = this.props;

    setSearchField("sex", "");
    setSearchField("general", "");
    setSearchField("localization", "");
    setSearchField("agencyUID", agencyUID);
    setPage(1);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  redirectToSingle(uid) {
    const { pathname } = this.props;

    this.redirect("/offer/" + uid);
  }

  setSort(field, dir) {
    const { setSort } = this.props;

    setSort(field, dir);
  }

  render() {
    const { showPagination, showHeader } = this.props;
    const {
      map,
      results,
      meta,
      setPage,
      setSearchField,
      generateSearchHash
    } = this.props;
    const result = results && results.get(hashFromObj(meta && meta.toJS()));

    const rows =
      result &&
      result.offers &&
      result.offers.map(r => {
        return (
          <div
            key={map.getIn([r, "uid"])}
            className="single-item"
            onClick={this.redirectToSingle.bind(this, map.getIn([r, "slug"]))}
          >
            <Container>
              <Row className="flex-items-xs-middle flex-items-xs-center flex-items-md-left">
                {/*<Col
                  className="text-xs-center text-md-left flex-xs-top"
                  xs="12"
                  md="1"
                >
                  {map.getIn([r, "agency", "logoFileUID"]) &&
                    <img
                      className="offer-icon"
                      src={
                        apiHost +
                        "/v1/agency/image/" +
                          map.getIn([r, "agency", "logoFileUID"])
                      }
                    />}
                  </Col>*/}
                <Col xs="12" md="6">
                  <h2 className="offer-title">{map.getIn([r, "title"])}</h2>
                  <div className="offer-agency">
                    {map.getIn([r, "agency", "name"]) ||
                      map.getIn([r, "agencyName"])}
                    , data dodania:{" "}
                    {moment(map.getIn([r, "createdAt"])).format("DD.MM.YYYYr.")}
                  </div>
                  <div className="offer-short">
                    {map.getIn([r, "shortDesc"])}
                  </div>
                </Col>
                <Col
                  className="flex-items-xs-center flex-items-md-left"
                  xs="12"
                  md="3"
                >
                  <div className="offer-localization">
                    <i className="fa fa-map-marker" />
                    {map.getIn([r, "code"])} {map.getIn([r, "city"])}
                  </div>
                  <div className="offer-localization">
                    <i className="fa fa-calendar-check-o" />
                    Termin wyjazdu:{" "}
                    {moment(map.getIn([r, "startDate"])).format("DD.MM.YYYYr.")}
                  </div>
                </Col>
                <Col className="text-xs-center text-md-right" xs="12" md="3">
                  <Link
                    className="show-offer btn btn-secondary btn-lg"
                    to={`/offer/${map.getIn([r, "slug"])}`}
                  >
                    ZOBACZ OFERTĘ
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        );
      });

    return (
      <div className="offers-section agency-offers-section">
        <div
          id="offers"
          className={
            showHeader
              ? "width-wrapper offers-top"
              : "width-wrapper offers-bottom agency-offers-bottom"
          }
        >
          {showHeader && (
            <Form
              className="offers-header"
              noValidate
              onSubmit={e => {
                e.preventDefault();
              }}
            >
              <Input
                className="search-input"
                placeholder="Czego szukasz?"
                size="lg"
                onChange={({ target: { value } }) =>
                  setSearchField("general", value)
                }
              />
              <Input
                className="search-input"
                placeholder="Kod lub miasto"
                size="lg"
                onChange={({ target: { value } }) =>
                  setSearchField("localization", value)
                }
              />
              <Input
                className="search-input"
                size="lg"
                type="select"
                onChange={({ target: { value } }) =>
                  setSearchField("sex", value)
                }
              >
                <option value="">Pacjent: obojętnie</option>
                <option value="mężczyzna">Pacjent: mężczyzna</option>
                <option value="kobieta">Pacjent: kobieta</option>
                <option value="dziecko">Pacjent: dziecko</option>
                <option value="2 osoby">Pacjent: 2 osoby</option>
              </Input>

              <Button
                className="search-button"
                color="primary"
                onClick={() => {
                  generateSearchHash();
                  setPage(1);
                }}
              >
                Szukaj
              </Button>
            </Form>
          )}
          <div className="offers-content">
            {showHeader && (
              <div className="offers-table-header">
                <FormGroup check>
                  <Label className="custom-control custom-radio" check>
                    <Input
                      className="custom-control-input"
                      type="radio"
                      name="sorting"
                      onClick={this.setSort.bind(this, "start_date", "asc")}
                      defaultChecked
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">
                      Najbliższy termin wyjazdu
                    </span>
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label className="custom-control custom-radio" check>
                    <Input
                      className="custom-control-input"
                      type="radio"
                      name="sorting"
                      onClick={this.setSort.bind(this, "start_date", "desc")}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">
                      Najdalszy termin wyjazdu
                    </span>
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label className="custom-control custom-radio" check>
                    <Input
                      className="custom-control-input"
                      type="radio"
                      name="sorting"
                      onClick={this.setSort.bind(this, "created_at", "desc")}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">
                      Najnowsze
                    </span>
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label className="custom-control custom-radio" check>
                    <Input
                      className="custom-control-input"
                      type="radio"
                      name="sorting"
                      onClick={this.setSort.bind(this, "created_at", "asc")}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">
                      Najstarsze
                    </span>
                  </Label>
                </FormGroup>
              </div>
            )}
            <div className="offers-table">
              {rows ? (
                rows.length === 0 ? (
                  <div className="loading-spinner">
                    Brak ofert dla podanych kryteriów
                  </div>
                ) : (
                  rows
                )
              ) : (
                <div className="loading-spinner">
                  <i className="loading-spinner fa fa-2x fa-circle-o-notch fa-spin" />
                </div>
              )}
            </div>
          </div>
          {showPagination && (
            <div className="offers-pagination">
              <Pagination
                numberOfPages={
                  result && Math.ceil(result.meta.all / meta.get("limit"))
                }
                currentPage={meta.get("currentPage")}
                maxPagesDisplay={5}
                setPage={setPage}
                afterPageChange={() => {
                  document.getElementById("offers").scrollIntoView();
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

Offers.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    map: state.offer.map,
    results: state.offer.results,
    meta: state.offer.meta
  }),
  { setPage, setSort, setSearchField, generateSearchHash }
)(Offers);



/** WEBPACK FOOTER **
 ** ./src/browser/offers/Offers.js
 **/